import React from 'react';
import PublicPageShell from '../components/PublicPageShell';
import IndustryPageTemplate from '../components/IndustryPageTemplate';
import { useLanguage } from '../contexts/LanguageContext';
import { getLocalizedIndustry } from '../data/industries';

const IndustryContent = ({ industryId }) => {
  const { currentLang } = useLanguage();
  const page = getLocalizedIndustry(industryId, currentLang);

  if (!page) {
    return null;
  }

  return <IndustryPageTemplate page={page} />;
};

const IndustryDetailPage = ({ industryId }) => (
  <PublicPageShell>
    <IndustryContent industryId={industryId} />
  </PublicPageShell>
);

export default IndustryDetailPage;
